import React from "react";
import Button from "./Button";

const ButtonTS = ({ children, ...props }) => {
  return <Button {...props}>{children}</Button>;
};

export default ButtonTS;
